import { render, staticRenderFns } from "./BusinessHeader.vue?vue&type=template&id=e995b8e2&"
import script from "./BusinessHeader.vue?vue&type=script&lang=js&"
export * from "./BusinessHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports